import { Button, Stack, Typography, styled } from "@mui/material";

export const StyledEditButton = styled(Button)(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: 600,
  color: theme.typography.textLinks.color,
  textDecoration: `underline ${theme.typography.textLinks.color}`,
  width: theme.spacing(7.5),
  height: theme.spacing(3),
}));

export const StyledReviewSectionHeader = styled(Stack)(() => ({
  flexDirection: "row",
  justifyContent: "space-between",
}));

export const StyledReviewFieldStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(1.5),
  flexWrap: "wrap",
}));

export const StyledReviewFieldLabelTypography = styled(Typography)(() => ({
  fontSize: "1rem",
  fontWeight: 600,
}));

export const StyledReviewFieldValueTypography = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.text.secondary,
    fontWeight: 400,
    wordBreak: "break-all"
  }),
);
